import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCarrier } from 'contracts/Carriers';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_CARRIERS_',
  }
);

export interface ListCarriersState {
  data: ListedCarrier[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCarriersRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCarrier[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCarriersState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCarriersState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ListCarriersState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ListCarriersState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCarriersState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listCarriers = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCarriersTypes = Types;
export const ListCarriersActions = Creators;
